// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__38VZM","col":"Table_col__25z_L","fulfillmentStatus":"Table_fulfillmentStatus__6khqT","emailCol":"Table_emailCol__2j-JH"};